import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { StoreSettings } from "@/types";

interface SettingsState {
  data: StoreSettings;
  loading: boolean;
  error: string | null;
}

const initialState: SettingsState = {
  data: {},
  loading: false,
  error: null,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSettings(state, action: PayloadAction<StoreSettings | null>) {
      state.data = action.payload ?? {};
    },
    patchSettings(state, action: PayloadAction<Partial<StoreSettings> | null>) {
      state.data = { ...state.data, ...(action.payload ?? {}) };
    },
    setSettingsLoading(state, action: PayloadAction<boolean>) {
      state.loading = Boolean(action.payload);
    },
    setSettingsError(state, action: PayloadAction<string | null>) {
      state.error = action.payload ?? null;
    },
  },
});

export const {
  setSettings,
  patchSettings,
  setSettingsLoading,
  setSettingsError,
} = settingsSlice.actions;

export default settingsSlice.reducer;
